import {useEffect, useState} from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import parse from "html-react-parser";


function App() {
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");

    const [step, setStep] = useState(1);
    const [mode, setMode] = useState("");


    const [input, setInput] = useState("");
    const [reply, setReply] = useState("");
    const [plate, setPlate] = useState("");
    const [plateValid, setPlateValid] = useState(null);
    const [plateInfo, setPlateInfo] = useState("");
    const [km, setKm] = useState("");

    const [doeleinde, setDoeleinde] = useState("");
    const [kennis, setKennis] = useState("");

    const [symptoms, setSymptoms] = useState([]);
    const [warningLight, setWarningLight] = useState("");
    const [locations, setLocations] = useState([]);
    const [frequency, setFrequency] = useState([]);
    const [severeness, setSevereness] = useState([]);
    const [extras, setExtras] = useState([]);

    const [symptomInput, setSymptomInput] = useState("");
    const [locationInput, setLocationInput] = useState("");
    const [frequencyInput, setFrequencyInput] = useState("");
    const [severenessInput, setSeverenessInput] = useState("");
    const [extraInput, setExtraInput] = useState("");

    const formatPlate = (value) => {

        const cleaned = value
            .replace(/[^a-zA-Z0-9]/g, "")
            .toUpperCase()
            .slice(0, 8);

        if (cleaned.length <= 2) return cleaned;
        if (cleaned.length <= 4) return `${cleaned.slice(0,2)}-${cleaned.slice(2)}`;
        return `${cleaned.slice(0,2)}-${cleaned.slice(2,4)}-${cleaned.slice(4)}`;
    };

    useEffect(() => {

        const cleanPlate = plate.replace(/-/g, "");

        if (cleanPlate.length < 6) {
            setPlateValid(null);
            return;
        }

        const timeout = setTimeout(async () => {
            setPlateValid(null);
            try {
                const API_URL = "https://carproblemsserver-1mea.onrender.com/api";
                const res = await axios.get(`https://carproblemsserver-1mea.onrender.com/api/vehicle/${cleanPlate}`);
                if (!res.data.exists) {
                    setPlateValid(false);
                    return;
                }
                console.log(res.data.exists)
                setPlateValid(true);
                setPlateInfo(`${res.data.car.brand} - ${res.data.car.model} (${res.data.car.year?.slice(0, 4)})
                `)


            } catch (err) {
                console.log(err)
                setPlateValid(false);
            }
        }, 500);

        return () => clearTimeout(timeout);

    }, [plate]);

    const toggleOption = (value, state, setState) => {
        setState((prev) => {
            const updated = prev.includes(value)
                ? prev.filter((v) => v !== value)
                : [...prev, value];

            console.log(updated); // ✅ correct

            return updated;
        });
    };

    const goBack = () => {
        if (step === 9) setStep(2);
        else if (step === 2) setStep(1);
    };

    const doeleindeOpties = [
        "Zelf repareren",
        "Naar automonteur"
    ]
    const kennisOpties = [
        "Geen autokennis",
        "Aan het leren",
        "Ervaren monteur"
    ]

    const symptoomOpties = [
        "Kloppend / tikkend geluid",
        "Piepend geluid",
        "Schurend / slijpend geluid",
        "Trilling",
        "Vermogensverlies",
        "Moeilijk starten",
        "Waarschuwingslampje",
        "Oververhitting",
        "Rook / geur"
    ]
    const locatieOpties = [
        "Voorzijde",
        "Achterzijde",
        "Linkerkant",
        "Rechterkant",
        'Midden van de auto',
        "Motorruimte",
        "Onder de auto",
        "In de auto"
    ]
    const frequentieOpties = [
        "Bij drempels / hobbelige weg",
        "Tijdens accelereren",
        "Tijdens remmen",
        "Tijdens sturen",
        "Op hoge snelheid",
        "Op lage snelheid",
        "Alleen bij koude motor",
        "Constant aanwezig",
        "Alleen stationair"
    ]
    const hevigheidOpties = [
        "Wordt langzaam erger",
        "Ontstond plotseling",
        "Soms aanwezig",
        "Altijd aanwezig"
    ]
    const extraOpties = [
        "Recent onderhoud gehad",
        "Recent onderdelen vervangen",
        "Schade / botsing gehad"
    ]

    const startLoadingMessages = () => {
        const messages = [
            "Diagnose wordt gestart...",
            "Voertuiggegevens worden geanalyseerd...",
            "Bekende problemen worden gecontroleerd...",
            "Oorzaken worden berekend...",
            "Bijna klaar..."
        ];

        let i = 0;

        setLoadingText(messages[0]);

        const interval = setInterval(() => {
            i++;

            if (i >= messages.length) {
                clearInterval(interval);
                return;
            }

            setLoadingText(messages[i]);
        }, 3000);

        return interval;
    };
    const sendMessage = async () => {
        setLoading(true);
        setStep(9);
        if (reply !== "") {
            setReply("")
        }

        const interval = startLoadingMessages();

        let prompt = {}
        if (mode === "form") {
            prompt = {
                ...(plate && {plate: plate}),
                ...(km && {km: km}),
                ...(doeleinde && {doeleinde: doeleinde}),
                ...(kennis && {kennis: kennis}),
                ...(symptoms.length > 0 && {symptoms: symptoms}),
                ...(symptomInput && {symptomInput: symptomInput}),
                ...(warningLight && {warningLight: warningLight}),
                ...(locations.length > 0 && {locations: locations}),
                ...(locationInput && {locationInput: locationInput}),
                ...(frequency.length > 0 && {frequency: frequency}),
                ...(frequencyInput && {frequencyInput: frequencyInput}),
                ...(severeness.length > 0 && {severeness: severeness}),
                ...(severenessInput && {severenessInput: severenessInput}),
                ...(extras.length > 0 && {extras: extras}),
                ...(extraInput && {extraInput: extraInput})
            }
        } else {
            prompt = {
                ...(plate && {plate: plate}),
                ...(km && {km: km}),
                ...(doeleinde && {doeleinde: doeleinde}),
                ...(kennis.length && {kennis: kennis}),
                ...(input && {message: input})
            }
        }


        console.log(prompt)
        try {
            const API_URL = "https://carproblemsserver-1mea.onrender.com/api"
            const res = await axios.post(`https://carproblemsserver-1mea.onrender.com/api/chat`, prompt);

            setReply(res.data.reply);
        } catch (err) {
            console.error("API error:", err);
            setReply("Er ging iets fout")
        } finally {
            clearInterval(interval);
            setLoading(false);
        }

    };

    return (
        <div className="min-h-screen bg-slate-900 text-white top-0 pb-10">
            <div className="text-center z-50 px-1 bg-slate-900 border-b border-b-slate-700 fixed w-full top-0 py-5 mb-5">
                <h1 className="lg:text-4xl text-3xl font-extrabold mb-1 text-slate-100">
                    Auto Probleem Gids
                </h1>
                <h3 className="text-xl font-bold mb-2 italic text-slate-200">
                    Drive it. Break it. Diagnose it.
                </h3>
                <p className="text-slate-400 lg:font-bold text-sm">Slimme voertuigdiagnose en garagehulp voor de auto
                    eigenaren en de doe-het-zelver.</p>
            </div>
            <div className="md:pt-36 pt-40 max-w-2xl mx-2 mt-2 sm:mx-auto ">
                {step !== 1 && (
                    <div className="top-40 right-80 flex justify-end z-20">
                        <button
                            className="fixed italic font-semibold mt-2 bg-slate-950 mr-2 hover:bg-slate-500 p-2 px-4 shadow-slate-900 shadow-lg transition rounded-lg"
                            onClick={goBack}
                        >
                            ← Terug
                        </button>
                    </div>
                )}

                {/*Beginpagina*/}
                {step === 1 && (
                    <div className="bg-slate-800 rounded-2xl shadow-xl p-8">
                        <label className="font-semibold text-slate-300 mb-1 block">
                            Kenteken:
                        </label>
                        <div className="block md:flex mb-3">
                            <div
                                className="flex items-center bg-yellow-400 rounded-lg overflow-hidden border-2 border-black w-full max-w-xs">

                                {/* EU / NL blauwe strip */}
                                <div
                                    className="bg-blue-600 text-white px-2 py-3 text-xs font-bold flex flex-col items-center">
                                    <span>NL</span>
                                    <span className="text-[10px]">🇪🇺</span>
                                </div>

                                {/* input */}
                                <input
                                    value={plate}
                                    onChange={(e) => setPlate(formatPlate(e.target.value))}
                                    placeholder="12AB34"
                                    className={`bg-yellow-400 text-black font-mono font-extrabold text-xl tracking-[0.3em] uppercase text-center w-full outline-none
                                    ${ (plate.length > 8 || plateValid === false ) && "text-red-700"}
                                    ${plateValid === true && "text-green-900"}`}
                                />
                            </div>
                            {plate.length === 8 && (
                                <div className="md:ml-2 my-auto italic">
                                    {plateValid === null && (
                                        <p>Gegevens ophalen...</p>
                                    )}
                                    {plateValid === true && (
                                        <p><span className="mr-2">✓</span>{plateInfo}</p>
                                    )}
                                    {plateValid === false && (
                                        <p>Geen match gevonden met het ingevoerde kenteken</p>
                                    )}
                                </div>
                            )}

                        </div>

                        {/*kilometerstand*/}
                        <div className="w-full">
                            <label className="font-semibold text-slate-300 mb-1 block">
                                Kilometerstand:
                            </label>

                            <div className="flex">
                                <input
                                    value={km}
                                    onChange={(e) => setKm(e.target.value)}
                                    placeholder="bijv. 210000"
                                    className="w-full max-w-xs p-3 rounded-r-none rounded-xl bg-slate-700 border border-slate-600
                                 text-white placeholder-slate-400 font-semibold font-mono text-lg
                                 focus:outline-none focus:ring-2 focus:ring-blue-500
                                 transition"
                                />

                                <div className="rounded-r-xl bg-slate-700 flex border border-slate-600 text-slate-400 text-sm">
                                    <p className="my-auto px-2">
                                        km
                                    </p>
                                </div>

                            </div>

                            <p className="text-xs italic text-slate-400 mt-1 mb-3">
                            Vul de actuele kilometerstand in van de auto
                            </p>
                        </div>
                        <h4 className="font-semibold mb-1 pt-4 text-slate-300 mt-4 border-t border-slate-500">
                            Ik wil...
                        </h4>
                        <div className="mb-4 grid grid-cols-1 md:grid-cols-3 gap-3">
                            {doeleindeOpties.map((option) => {
                                return (
                                    <button
                                        key={option}
                                        onClick={() => setDoeleinde(option)}
                                        className={`py-2 px-3 rounded-xl border transition text-left
                                        ${doeleinde === option
                                            ? "bg-blue-600 border-blue-400 text-white"
                                            : "bg-slate-700 border-slate-600 hover:bg-slate-600"
                                        }`}
                                    >
                                        {option} {doeleinde === option && <span className="ml-2">✓</span>}
                                    </button>
                                );
                            })}
                        </div>
                        <h4 className="font-semibold text-slate-300 mb-1">Kennis...</h4>
                        <div className="mb-6 grid grid-cols-1 md:grid-cols-3 gap-3">
                            {kennisOpties.map((option) => {
                                return (
                                    <button
                                        key={option}
                                        onClick={() => setKennis(option)}
                                        className={`py-2 px-3 rounded-xl border transition text-left
                                        ${option === kennis
                                            ? "bg-green-600 border-green-400 text-white"
                                            : "bg-slate-700 border-slate-600 hover:bg-slate-600"
                                        }`}
                                    >
                                        {option} {option === kennis && <span className="ml-2">✓</span>}
                                    </button>
                                );
                            })}
                        </div>


                        <h2 className="text-xl font-bold mb-6 pt-4 mt-2 border-t border-slate-500">
                            Hoe wil je het probleem beschrijven?
                        </h2>

                        <button
                            className="w-full bg-blue-600 p-3 rounded mb-3"
                            onClick={() => {
                                setMode("form");
                                setStep(2);
                            }}>
                            Vragenlijst
                        </button>

                        <button
                            className="w-full bg-blue-800 p-3 rounded"
                            onClick={() => {
                                setMode("free");
                                setStep(2);
                            }}>
                            Zelf omschrijven
                        </button>

                    </div>
                )}

                {/*Formulier pagina*/}
                {step === 2 && mode === "form" && (

                    <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">
                        <h2 className="text-4xl font-bold mb-8">
                            Probleem omschrijving
                        </h2>

                        <div className="bg-slate-700 p-5 rounded-xl mt-6">
                            <h3 className="text-xl font-semibold mb-3">Wat merk je? *</h3>
                            <div className='mb-3'>
                                {symptoomOpties.map((option) => (
                                    <label
                                        key={option}
                                        className="flex items-center gap-2 py-1">
                                        <input
                                            type="checkbox"
                                            checked={symptoms.includes(option)}
                                            onChange={() => toggleOption(option, symptoms, setSymptoms)}
                                        />
                                        {option}

                                        {option === "Waarschuwingslampje" &&
                                            symptoms.includes("Waarschuwingslampje") && (
                                                <input
                                                    type="text"
                                                    placeholder="Welk lampje?"
                                                    value={warningLight}
                                                    onChange={(e) =>
                                                        setWarningLight(e.target.value)
                                                    }
                                                />
                                            )}
                                    </label>
                                ))}
                            </div>
                            <p>Eigen omschrijving</p>
                            <input
                                className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={symptomInput}
                                onChange={(e) => setSymptomInput(e.target.value)}
                                placeholder="Omschrijf de symptomen"
                            />
                        </div>
                        <div className="bg-slate-700 p-5 rounded-xl mt-6">
                            <h3 className="text-xl font-semibold">Waar merk je het?</h3>
                            <p className="mb-3">(optioneel)</p>
                            <div className="mb-3">
                                {locatieOpties.map((option) => (
                                    <label key={option} className="flex items-center gap-2 py-1">
                                        <input
                                            type="checkbox"
                                            checked={locations.includes(option)}
                                            onChange={() => toggleOption(option, locations, setLocations)}
                                        />
                                        {option}
                                    </label>
                                ))}
                            </div>
                            <p>Eigen omschrijving</p>
                            <input
                                className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={locationInput}
                                onChange={(e) => setLocationInput(e.target.value)}
                                placeholder="Beschrijf waar je het probleem ervaart"
                            />
                        </div>
                        <div className="bg-slate-700 p-5 rounded-xl mt-6">
                            <h3 className="text-xl font-semibold">Wanneer merk je het?</h3>
                            <p className="mb-3">(optioneel)</p>
                            {frequentieOpties.map((option) => (
                                <label key={option} className="flex items-center gap-2 py-1">
                                    <input
                                        type="checkbox"
                                        checked={frequency.includes(option)}
                                        onChange={() => toggleOption(option, frequency, setFrequency)}
                                    />
                                    {option}
                                    <br/>
                                </label>
                            ))}
                            <p>Eigen omschrijving</p>
                            <input
                                className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={frequencyInput}
                                onChange={(e) => setFrequencyInput(e.target.value)}
                                placeholder="Beschrijf wanneer je het probleem ervaart"
                            />
                        </div>
                        <div className="bg-slate-700 p-5 rounded-xl mt-6">
                            <h3 className="text-xl font-semibold">Hoe hevig is het?</h3>
                            <p className="mb-3">(optioneel)</p>
                            {hevigheidOpties.map((option) => (
                                <label key={option} className="flex items-center gap-2 py-1">
                                    <input
                                        type="checkbox"
                                        checked={severeness.includes(option)}
                                        onChange={() => toggleOption(option, severeness, setSevereness)}
                                    />
                                    {option}
                                    <br/>
                                </label>
                            ))}
                            <p>Eigen omschrijving</p>
                            <input
                                className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={severenessInput}
                                onChange={(e) => setSeverenessInput(e.target.value)}
                                placeholder="Beschrijf hoe hevig het is"
                            />
                        </div>
                        <div className="bg-slate-700 p-5 rounded-xl mt-6">
                            <h3 className="text-xl font-semibold">Meer informatie</h3>
                            <p className="mb-3">(optioneel)</p>
                            {extraOpties.map((option) => (
                                <label key={option} className="flex items-center gap-2 py-1">
                                    <input
                                        type="checkbox"
                                        checked={extras.includes(option)}
                                        onChange={() => toggleOption(option, extras, setExtras)}
                                    />
                                    {option}
                                    <br/>
                                </label>
                            ))}
                            <p>Eigen omschrijving</p>
                            <input
                                className="w-full p-3 rounded-lg bg-slate-700 border border-slate-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                value={extraInput}
                                onChange={(e) => setExtraInput(e.target.value)}
                                placeholder="Beschrijf overige belangrijke informatie"
                            />
                        </div>

                        <button
                            className="w-full bg-blue-600 p-3 rounded mb-3"
                            onClick={sendMessage}>
                            Start diagnose
                        </button>
                    </div>
                )}

                {/*Zelf invullen pagina*/}
                {step === 2 && mode === "free" && (

                    <div className="max-w-2xl mx-auto bg-slate-800 rounded-2xl shadow-xl p-8">

                        <h2 className="text-4xl font-bold">
                            Probleem omschrijving
                        </h2>
                        <h3 className="text-2xl font-bold mb-8">
                            Zelf invullen
                        </h3>
                        <p className="mb-2 text-sm text-slate-400">
                            Let op: omschrijf het probleem zo gedetailleerd mogenlijk. Denk aan geluiden, wanneer het
                            gebeurt (bijv. bij starten, remmen, snelheid),
                            en of er waarschuwingslampjes branden etc.
                        </p>
                        <textarea
                            className="w-full p-4 rounded-xl bg-slate-700 border border-slate-600
             text-white placeholder-slate-400
             focus:outline-none focus:ring-2 focus:ring-blue-500
             transition resize-none"
                            rows={5}
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder="Beschrijf het probleem..."
                        />
                        <br/>
                        <button
                            className="w-full bg-blue-600 p-3 rounded mb-3"
                            onClick={sendMessage}>
                            Diagnose starten
                        </button>
                    </div>
                )}

                {/*Diagnose*/}
                {step === 9 && (
                    <div className="max-w-2xl mx-auto bg-slate-800 text-slate-200 leading-relaxed rounded-2xl shadow-xl p-8">
                        <h2 className="text-4xl font-bold mb-8">
                            Diagnose
                        </h2>
                        {loading && (
                            <div className="mt-4 bg-slate-800 p-4 rounded-lg">
                                <p>{loadingText}</p>
                            </div>
                        )}
                        <div className="white-space:pre-wrap; whitespace-pre-wrap max-w-none">
                            {reply}
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}


export default App;
